import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import AsyncCreatableSelect from 'react-select/async-creatable';
import axios from 'axios';
import Button from '@/app/_components/buttons/Button';
import { useMediaQuery } from '@/app/_components/utils/hooks';
import config from '@/tailwind.config';
const schoolsUrl = '/api/taxonomy/schools';

interface Props {
  step: string;
  hasNext: boolean;
  onNext: () => void;
}
const OnboardingSchool = ({ step, hasNext, onNext }: Props) => {
  const {
    register,
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const watchSchool = watch('school', false);

  const isMobile = useMediaQuery(
    // @ts-ignore
    `(max-width: ${config.theme.screens['md']})`
  );

  if (step !== 'SCHOOL') {
    return null;
  }

  const loadOptions = (inputValue: string) => {
    return axios.get(`${schoolsUrl}?q=${inputValue}`).then(({ data }) =>
      data?.schools.map((school: string) => ({
        value: school,
        label: school,
      }))
    );
  };

  const createLabel = (input: string) => (
    <p>
      Add school:
      <span className="font-bold text-purple3"> {input}</span>
    </p>
  );
  const noOptionsMessage = () => null;

  return (
    <div className="w-full md:w-[430px]">
      <label
        htmlFor="school"
        className="text-white font-hanken text-4xl font-extrabold mb-8 block"
      >
        <span className="text-purple3">
          Hi! I’m ZocBot, your new AI assistant.
        </span>{' '}
        What school do you attend?
      </label>
      <>
        <Controller
          control={control}
          name="school"
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => {
            return (
              <AsyncCreatableSelect
                value={value}
                cacheOptions
                menuPlacement={isMobile ? 'top' : 'bottom'}
                {...register('school')}
                loadOptions={loadOptions}
                defaultOptions={[]}
                isSearchable={true}
                isClearable={true}
                onChange={onChange}
                placeholder="Start typing to find your school"
                noOptionsMessage={noOptionsMessage}
                formatCreateLabel={createLabel}
                classNames={{
                  control: () =>
                    'rounded-[3px] border border-grey4 border-solid my-4 px-4 py-3 font-hanken text-sm leading-7 !bg-transparent',
                  singleValue: () => '!text-white',
                  input: () => '!text-white',
                  indicatorSeparator: () => '!hidden',
                  dropdownIndicator: () => '!hidden',
                  clearIndicator: () => 'data-test-clear-input',
                  menu: () => 'data-test-schools-menu',
                }}
              />
            );
          }}
        />
        {hasNext && (
          <Button
            data-test-id="onboarding-next"
            className="!rounded-full min-w-[200px] my-8"
            variant="primary"
            type="button"
            label="Next"
            disabled={!watchSchool || watchSchool.length <= 0}
            onClick={onNext}
          />
        )}
      </>
    </div>
  );
};

export default OnboardingSchool;
